import React, { useState, useEffect } from 'react';
import Hero from '../components/Hero';
import About from '../components/About';
import ShopSection from '../components/ShopSection';
import Services from '../components/Services';
import Gallery from '../components/Gallery';
import Features from '../components/Features';
import Promotion from '../components/Promotion';
import StoreInfo from '../components/StoreInfo';
import Quote from '../components/Quote';
import NewArrivals from '../components/NewArrivals';
import ContactForm from '../components/ContactForm';
import YearsPopup from '../components/YearsPopup';

const Home = () => {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    // Show popup every time user visits the home page
    const timer = setTimeout(() => {
      setShowPopup(true);
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div>
      {/* 52 Years Popup */}
      <YearsPopup isOpen={showPopup} onClose={() => setShowPopup(false)} />
      <Hero />
      <About />
      <ShopSection />
      <Services />
      <Gallery />
      <Features />
      <Promotion />
      <StoreInfo />
      <Quote />
      <NewArrivals />
      <ContactForm />
    </div>
  );
};

export default Home;
